export const enValeurs ={
    "our": "OUR",
    "title": "VALUES",
    "subTitle": "STRONG VALUES THAT GUIDE US",
    "titre-card1": "Comprehensive Digital Expertise",
      "titre-card2": "Tailored Solutions",
      "titre-card3": "Innovation and Creativity",
      "titre-card4": "Transparent Communication",
      "titre-card5": "Measurable Results",
      "titre-card6": "Long-Term Partnerships",
      "para1-card": "Our team boasts in-depth expertise across every facet of the digital landscape, ensuring excellence in every project.",
      "para2-card": "We deliver personalized strategies, crafted to meet the unique needs and goals of each client.",
      "para3-card": "We empower our clients with innovative and creative solutions that distinguish them in a competitive market.",
      "para4-card": "We maintain open and clear communication, keeping our clients informed at every stage to ensure seamless collaboration.",
      "para5-card": "Our strategies are designed to deliver tangible, measurable outcomes, driving continuous improvement and success.",
      "para6-card": "We prioritize building lasting relationships, supporting our clients' growth and adapting to their evolving needs.",
}

export const frValeurs = {
    "our": "NOS",
    "title": "VALEURS",
    "subTitle": "VALEURS FORTES QUI NOUS GUIDENT",
    "titre-card1": "Expertise Numérique Complète",
    "titre-card2": "Solutions Personnalisées",
    "titre-card3": "Innovation et Créativité",
    "titre-card4": "Communication Transparente",
    "titre-card5": "Résultats Mesurables",
    "titre-card6": "Partenariats à Long Terme",
    "para1-card": "Notre équipe possède une expertise approfondie dans tous les aspects du paysage numérique, garantissant l'excellence de chaque projet.",
    "para2-card": "Nous livrons des stratégies personnalisées, conçues pour répondre aux besoins et objectifs uniques de chaque client.",
    "para3-card": "Nous habilitons nos clients avec des solutions innovantes et créatives qui les distinguent sur un marché concurrentiel.",
    "para4-card": "Nous maintenons une communication ouverte et claire, tenant nos clients informés à chaque étape pour garantir une collaboration sans faille.",
    "para5-card": "Nos stratégies sont conçues pour fournir des résultats tangibles et mesurables, favorisant l'amélioration continue et le succès.",
    "para6-card": "Nous priorisons la construction de relations durables, soutenant la croissance de nos clients et nous adaptant à leurs besoins évolutifs.",
}

export const nlValeurs = {
    "our": "ONZE",
    "title": "WAARDEN",
    "subTitle": "STERKE WAARDEN DIE ONS LEIDEN",
    "titre-card1": "Uitgebreide Digitale Expertise",
    "titre-card2": "Maatwerkoplossingen",
    "titre-card3": "Innovatie en Creativiteit",
    "titre-card4": "Transparante Communicatie",
    "titre-card5": "Meetbare Resultaten",
    "titre-card6": "Langdurige Partnerschappen",
    "para1-card": "Ons team beschikt over diepgaande expertise in elk facet van het digitale landschap, wat uitmuntendheid in elk project garandeert.",
    "para2-card": "Wij leveren persoonlijke strategieën, afgestemd op de unieke behoeften en doelen van elke klant.",
    "para3-card": "Wij bieden onze klanten innovatieve en creatieve oplossingen die hen onderscheiden in een concurrerende markt.",
    "para4-card": "Wij houden open en duidelijke communicatie, zodat onze klanten op elk moment geïnformeerd zijn en samenwerking soepel verloopt.",
    "para5-card": "Onze strategieën zijn ontworpen om tastbare, meetbare resultaten te leveren, wat voortdurende verbetering en succes stimuleert.",
    "para6-card": "Wij geven prioriteit aan het opbouwen van duurzame relaties, ondersteunen de groei van onze klanten en passen ons aan hun veranderende behoeften aan.",
}

export const deValeurs = {
    "our": "UNSERE",
    "title": "WERTE",
    "subTitle": "STARKE WERTE, DIE UNS LEITEN",
    "titre-card1": "Umfassende Digitale Expertise",
    "titre-card2": "Maßgeschneiderte Lösungen",
    "titre-card3": "Innovation und Kreativität",
    "titre-card4": "Transparente Kommunikation",
    "titre-card5": "Messbare Ergebnisse",
    "titre-card6": "Langfristige Partnerschaften",
    "para1-card": "Unser Team verfügt über umfassende Expertise in allen Bereichen der digitalen Landschaft und garantiert Exzellenz in jedem Projekt.",
    "para2-card": "Wir liefern individuelle Strategien, die auf die einzigartigen Bedürfnisse und Ziele jedes Kunden zugeschnitten sind.",
    "para3-card": "Wir ermöglichen unseren Kunden innovative und kreative Lösungen, die sie in einem wettbewerbsintensiven Markt hervorheben.",
    "para4-card": "Wir pflegen eine offene und klare Kommunikation, halten unsere Kunden in jeder Phase informiert und sorgen für eine reibungslose Zusammenarbeit.",
    "para5-card": "Unsere Strategien sind darauf ausgelegt, greifbare, messbare Ergebnisse zu liefern, die kontinuierliche Verbesserung und Erfolg fördern.",
    "para6-card": "Wir legen Wert auf den Aufbau langfristiger Beziehungen, unterstützen das Wachstum unserer Kunden und passen uns ihren sich wandelnden Bedürfnissen an.",
}